import React from "react";
import { Table, InputNumber, Form, Select, Space } from "antd";
import get from "lodash/get";
import map from "lodash/map";

import {
  validatePartWeight,
} from "../../../utilities/shift";

import RejectedScrapTypeSelect from "./rejectedScrapTypeSelect";

const PartExtrutionSettings = ({ name, partsData, form, config }) => {

  if (!get(partsData, "length")) return null;

  const columns = [
    {
      title: "Part Name",
      dataIndex: "name",
      width: 200,
      render: (_, record) => (
        <p className="inline-block">
          <p className="text-xs break-words">{get(record, "name", "--")}</p>
          {get(record, "item_id") && (
            <p className="text-xs break-words">{get(record, "item_id", "--")}</p>
          )}
        </p>
      ),
    },
    {
      title: "Planned Length",
      dataIndex: ["meta", "planned_length"],
      align:"center",
      width: 180,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[
            name,
            "parts_full",
            rowIndex,
            "meta",
            "planned_length",
          ]}
          rules={[{ required: true, message: "Planned length" }, { type: "number", min: 1, message: "Planned length should be greater than 1" }]}
        >
          <InputNumber
            placeholder="Count"
            size="small"
            addonAfter="meter"
            defaultValue={0}
            onChange={(value) => {
              form.setFieldValue(
                [
                  "components",
                  name,
                  "parts_full",
                  rowIndex,
                  "meta",
                  "planned_length",
                ],
                value
              );
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "Rejected Length",
      dataIndex: ["meta", "rejected_length"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[
            name,
            "parts_full",
            rowIndex,
            "meta",
            "rejected_length",
          ]}
        >
          <InputNumber
            className="w-full"
            placeholder="Count"
            size="small"
            addonAfter="meter"
            defaultValue={0}
            onChange={(value) => {
              form.setFieldValue(
                [
                  "components",
                  name,
                  "parts_full",
                  rowIndex,
                  "meta",
                  "rejected_length",
                ],
                value
              );
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "Part Weight/Meter",
      dataIndex: ["meta", "part_weight"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "part_weight"]}
          rules={[validatePartWeight(name, rowIndex)]}
        >
          <InputNumber
            className="w-full"
            placeholder="Part weight"
            addonAfter="gm"
            size="small"
            defaultValue={0}
            precision={2}
          />
        </Form.Item>
      ),
    },
    {
      title: "Rejected scrap type",
      dataIndex: ["meta", "rejected_scrap_type"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <RejectedScrapTypeSelect form={form} rowIndex={rowIndex} name={name} config={config} />
      ),
    },
    {
      title: "Scrap weight (in Kg)",
      dataIndex: ["meta", "rejected_scrap_weight"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "rejected_scrap_weight"]}
        >
          <InputNumber
            className="w-full"
            placeholder="Rejected scrap weight (in Kg)"
            addonAfter="kg"
            size="small"
            defaultValue={0}
            precision={2}
          />
        </Form.Item>
      ),
    },
    {
      title: "Process",
      dataIndex: ["meta", "process"],
      align:"center",
      width: 200,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "process"]}
          rules={[validatePartWeight(name, rowIndex)]}
        >
          <Select
            options={map(get(config, "extrusion_process"), item => {
              return {
                ...item,
                label: get(item, "name"),
              }
            })}
            className="w-full"
            placeholder="Process"
            addonAfter="gm"
            size="small"
            precision={2}
          />
        </Form.Item>
      ),
    },
      {
        title: "Job / Contratual / Profit Cost",
        dataIndex: ["meta", "costings"],
        minWidth:200,
        render: (_, __, rowIndex) => (
          <Space.Compact>
            <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "job_cost_per_pc"]} label="" >
              <InputNumber placeholder="Job"
                style={{ width: "100%" }} size="small"
                prefix="₹"
                defaultValue={0}
              />
            </Form.Item>
  
            <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "contractual_cost_per_pc"]} label="">
              <InputNumber placeholder="Contratual"
                style={{ width: "100%" }} size="small"
                prefix="₹"
                defaultValue={0}
              />
            </Form.Item>
  
            <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "profit_per_pc"]} label="">
              <InputNumber placeholder="Profit"
                style={{ width: "100%" }} size="small"
                prefix="₹"
                defaultValue={0}
              />
            </Form.Item>
          </Space.Compact>
        ),
      },
  ];

  return (
    <Table
      size="small"
     rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      pagination={false}
      dataSource={partsData}
      columns={columns}
      scroll={{ x: true }}
      bordered
      onHeaderRow={(columns, index) => {
        return {
          className: "text-xs",
        };
      }}
      onRow={() => {
        return {
          className: "text-xs",
        };
      }}
    />
  );
};
export default PartExtrutionSettings;
